var _classCallCheck = require("/opt/build/repo/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/website/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/website/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/opt/build/repo/website/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UnableToFetchPostDataError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(UnableToFetchPostDataError, _Error);

  var _super = _createSuper(UnableToFetchPostDataError);

  function UnableToFetchPostDataError(shortcode) {
    _classCallCheck(this, UnableToFetchPostDataError);

    return _super.call(this, shortcode);
  }

  _createClass(UnableToFetchPostDataError, null, [{
    key: "fromShortcode",
    value: function fromShortcode(shortcode) {
      return new this("An error occured while fetching post data for shortcode ".concat(shortcode, ". Maybe this post does not exist ?"));
    }
  }]);

  return UnableToFetchPostDataError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

module.exports = UnableToFetchPostDataError;